<template>
  <div>
    <v-container>
      <v-card>
        <v-card-text style="padding: 0px">
          <template>
            <v-toolbar color="primary" light>
              <v-toolbar-title class="white--text">Banners</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items class="hidden-sm-and-down">
                <v-btn
                  color="white"
                  dark
                  flat
                  @click="dialog = true"
                  :disabled="!vid"
                  >Add New</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
          </template>
        </v-card-text></v-card
      ></v-container
    >
    <v-container>
      <v-toolbar flat color="white" dense style="margin-bottom:0px">
        <v-btn color="success" small @click="loadBanners()"
          ><v-icon>mdi-refresh</v-icon> Refresh</v-btn
        >
        <v-btn
          color="danger"
          class="white--text"
          small
          @click="deleteBanner()"
          :disabled="!selectedBanners.length > 0"
          ><v-icon>mdi-delete</v-icon> Delete</v-btn
        >
        <v-btn
          color="primary"
          small
          @click="editBanner()"
          :disabled="!(selectedBanners.length == 1)"
          ><v-icon>mdi-lead-pencil</v-icon> Edit</v-btn
        >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <div style="width:200px;">
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </div>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="banners"
        :search="search"
        :loading="true"
        item-key="id"
        v-model="selectedBanners"
        select-all
        dense
        class="elevation-1"
      >
        <template slot="headerCell" slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-primary text--darken-3"
            v-text="header.text"
          ></span>
        </template>

        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              v-model="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td class="text-xs-center">
            <img
              :src="props.item.image"
              style="width:200px;height:auto;object-fit:cover;"
            />
          </td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.position }}</td>
          <td class="text-xs-center text-md-center">
            <v-switch
              v-model="props.item.active"
              color="primary"
              class="v-input--reverse"
              style="justify-content:center;"
              hide-details
              @change="updateActive(props.item.id, props.item.active)"
            >
              <template slot="label">
                Active
              </template>
            </v-switch>
          </td>
          <td>
            <v-chip
              color="green"
              text-color="white"
              :key="index"
              v-for="(p, index) in props.item.products"
            >
              <v-avatar class="green darken-4">
                <img :src="p.image" />
              </v-avatar>
              {{ p.name }}
            </v-chip>
          </td>
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-card>
          <v-card-title class="text-primary">
            <span class="headline">New Banner</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    align-center
                    text-xs-center
                    style="position:relative;"
                  >
                    <img
                      v-if="banner.image != ''"
                      @click="$refs.image.click()"
                      :src="banner.image"
                      style="width:200px;height:auto;object-fit:cover;"
                    />
                    <img
                      v-else
                      src="img/image.jpg"
                      @click="$refs.image.click()"
                      style="width:150px;height:150px;object-fit:cover;"
                    />
                    <v-flex
                      v-if="uploading"
                      d-flex
                      align-center
                      align-content-center
                      style="position:absolute;left:50%;margin-left:-75px;top:0;width:150px;height:150px;background:rgba(0,0,0,0.5);"
                    >
                      <v-progress-circular
                        :value="progress"
                        color="primary lighten-2"
                        size="75"
                      ></v-progress-circular>
                    </v-flex>
                    <v-text-field
                      @click="$refs.image.click()"
                      color="green"
                      placeholder="Select Image"
                      readonly
                      :value="banner.file.name"
                      :rules="rules.required"
                    ></v-text-field>
                    <input
                      type="file"
                      style="display: none"
                      ref="image"
                      accept="image/*"
                      @change="pickFile($event)"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      label="Title*"
                      :rules="rules.required"
                      required
                      v-model="banner.title"
                    ></v-text-field>
                    <v-select
                      v-model="banner.position"
                      :items="positions"
                      label="Position"
                      :rules="rules.required"
                    >
                    </v-select>
                    <v-select
                      v-model="clickable"
                      :items="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false },
                      ]"
                      label="attach products?"
                      item-text="text"
                      item-value="value"
                    >
                    </v-select>
                    <v-autocomplete
                      v-if="clickable"
                      v-model="banner.products"
                      :items="products"
                      item-text="name"
                      item-value="id"
                      label="Products"
                      single-line
                      small-chips
                      dense
                      :allow-overflow="false"
                      :rules="rules.required"
                      multiple
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          class="chip--select-multi"
                          @input="remove(data.item)"
                        >
                          <v-avatar>
                            <img :src="data.item.image" />
                          </v-avatar>
                          {{ data.item.name }}
                        </v-chip>
                      </template>
                      <template v-slot="item" slot-scope="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-tile-content
                            v-text="data.item"
                          ></v-list-tile-content>
                        </template>
                        <template v-else>
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-html="data.item.name"
                            ></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-html="data.item.group"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <v-switch
                      v-model="banner.active"
                      label="Available"
                      color="success"
                    ></v-switch>
                    <v-checkbox
                      v-model="banner.push_notification"
                      label="Notification"
                      color="primary"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              small
              outline
              @click.native="
                dialog = false;
                resetForm();
              "
              >Close</v-btn
            >
            <v-btn
              color="primary darken-1"
              small
              :disabled="!valid || uploading"
              @click.native="addBanner()"
              class="text--white"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog1" persistent max-width="800px">
        <v-card>
          <v-card-title class="text-primary">
            <span class="headline">Update Banner</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid1">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    align-center
                    text-xs-center
                    style="position:relative;"
                  >
                    <img
                      v-if="banner.image != ''"
                      @click="$refs.image.click()"
                      :src="banner.image"
                      style="width:200px;height:auto;object-fit:cover;"
                    />
                    <img
                      v-else
                      src="img/image.jpg"
                      @click="$refs.image.click()"
                      style="width:150px;height:150px;object-fit:cover;"
                    />
                    <v-flex
                      v-if="uploading"
                      d-flex
                      align-center
                      align-content-center
                      style="position:absolute;left:50%;margin-left:-75px;top:0;width:150px;height:150px;background:rgba(0,0,0,0.5);"
                    >
                      <v-progress-circular
                        :value="progress"
                        color="primary lighten-2"
                        size="75"
                      ></v-progress-circular>
                    </v-flex>
                    <v-text-field
                      @click="$refs.image.click()"
                      color="green"
                      placeholder="Select Image"
                      readonly
                      :value="banner.file.name"
                    ></v-text-field>
                    <input
                      type="file"
                      style="display: none"
                      ref="image"
                      accept="image/*"
                      @change="pickFile($event)"
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      label="Title*"
                      :rules="rules.required"
                      required
                      v-model="banner.title"
                    ></v-text-field>
                    <v-select
                      v-model="banner.position"
                      :items="positions"
                      label="Position"
                      :rules="rules.required"
                    >
                    </v-select>
                    <v-select
                      v-model="clickable"
                      :items="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false },
                      ]"
                      label="attach products?"
                      item-text="text"
                      item-value="value"
                      :rules="rules.required"
                    >
                    </v-select>
                    <v-autocomplete
                      v-if="clickable"
                      v-model="banner.products"
                      :items="products"
                      item-text="name"
                      item-value="id"
                      label="Products"
                      single-line
                      small
                      chips
                      multiple
                      :rules="rules.required"
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          class="chip--select-multi"
                          @input="remove(data.item)"
                        >
                          <v-avatar>
                            <img :src="data.item.image" />
                          </v-avatar>
                          {{ data.item.name }}
                        </v-chip>
                      </template>
                      <template v-slot="item" slot-scope="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-tile-content
                            v-text="data.item"
                          ></v-list-tile-content>
                        </template>
                        <template v-else>
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-html="data.item.name"
                            ></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-html="data.item.group"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <v-switch
                      v-model="banner.active"
                      label="Available"
                      color="success"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              small
              outline
              @click.native="
                dialog1 = false;
                resetForm();
              "
              >Close</v-btn
            >
            <v-btn
              color="primary darken-1"
              small
              :disabled="!valid1 || uploading"
              class="text--white"
              @click.native="updateBanner()"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog2" max-width="600px">
        <v-card>
          <v-card-title class="red--text">
            <h3>Warning !!</h3>
          </v-card-title>
          <v-card-text>
            Error: Something went wrong... Please try again.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn color="blue" flat @click="dialog2 = false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script type="text/javascript">
import api from '@/api';
export default {
  data() {
    return {
      search: '',
      uploading: false,
      selectedBanners: [],
      progress: 0,
      products: [],
      headers: [],
      banners: [],
      deletedId: '',
      dialog: false,
      clickable: false,
      banner: {
        image: '',
        fileUrl: '',
        title: '',
        position: '',
        active: true,
        products: [],
        file: '',
        push_notification: false,
      },
      rules: {
        required: [v => /^(?!\s*$).+/.test(v) || 'Name is required'],
      },
      dialog: false,
      dialog2: false,
      dialog1: false,
      valid: false,
      valid1: false,
      confirm: false,
    };
  },
  watch: {
    vid() {
      this.reload();
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
    positions() {
      var positions = [];
      if (!this.banners.some(b => b.position == 'top')) {
        positions.push({ text: 'Top', value: 'top' });
      } else {
        positions.push({ text: 'Top', value: 'top', disabled: true });
      }
      if (!this.banners.some(b => b.position == 'bottom')) {
        positions.push({ text: 'Bottom', value: 'bottom' });
      } else {
        positions.push({ text: 'Bottom', value: 'bottom', disabled: true });
      }
      positions.push({ text: 'Middle', value: 'middle' });
      return positions;
    },
  },
  methods: {
    loadBanners() {
      let loader = this.$loading.show();
      api
        .get('banners')
        .then(r => {
          this.banners = r.data;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.loadBanners();
            }
          }
        });
    },
    reload() {
      let loader = this.$loading.show();
      api
        .get('products')
        .then(r => {
          this.products = r.data;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.reload();
            }
          }
        });
      this.loadBanners();
    },
    pickFile(e) {
      if (e.target.files.length > 0) {
        this.banner.file = e.target.files[0];
        this.banner.image = URL.createObjectURL(this.banner.file);

        this.uploadImage(this.banner.file);
      }
    },
    uploadImage(file) {
      this.uploading = true;
      let formData = new FormData();
      formData.append('image', this.banner.file);
      api
        .post('upload/file', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progressEvent =>
            (this.progress = progressEvent.total),
        })
        .then(r => {
          if (r.data.file_url) {
            this.banner.image = r.data.file_url;
            this.uploading = false;
          } else {
            this.dialog2 = true;
          }
        })
        .catch(err => {
          this.dialog2 = true;
          this.uploading = false;
        });
    },
    addBanner() {
      if (this.valid) {
        let loader = this.$loading.show();
        api
          .post('banners', {
            image: this.banner.image,
            title: this.banner.title,
            active: this.banner.active,
            products: this.banner.products,
            position: this.banner.position,
            push_notification: this.banner.push_notification,
          })
          .then(r => {
            loader.hide();
            this.loadBanners();
            this.dialog = false;
            this.resetForm();
          })
          .catch(err => {
            loader.hide();
            this.dialog2 = true;
          });
      }
    },
    editBanner() {
      var c = this.selectedBanners[0];
      this.banner.id = c.id;
      this.banner.title = c.title;
      this.banner.image = c.image;
      this.banner.file = '';
      this.banner.products = c.products;
      this.banner.active = c.active;
      this.banner.position = c.position;
      this.valid1 = false;
      this.dialog1 = true;
      this.clickable = c.products.length > 0;
    },
    updateActive(id, v) {
      let loader = this.$loading.show();
      api.put('banners/' + id, { active: v }).then(r => {
        loader.hide();
      });
    },
    updateBanner() {
      if (this.valid1) {
        let loader = this.$loading.show();
        api
          .put('banners/' + this.banner.id, {
            image: this.banner.image,
            title: this.banner.title,
            active: this.banner.active,
            products: this.banner.products,
            position: this.banner.position,
          })
          .then(r => {
            loader.hide();
            this.loadBanners();
            this.resetForm();
            this.dialog1 = false;
          })
          .catch(() => {
            loader.hide();
            this.dialog2 = true;
          });
      }
    },
    async deleteBanner(e) {
      var res = await this.$dialog.confirm({
        text: 'Do you really want to delete?',
        title: 'Warning',
      });
      if (res) {
        let loader = this.$loading.show();
        var deletedIds = [];
        this.selectedBanners.forEach(p => deletedIds.push(p.id));
        api.post('banners/delete', { deletedIds }).then(r => {
          loader.hide();
          this.loadBanners();
          this.selectedBanners = [];
        });
      }
    },
    resetForm: function() {
      this.banner = {
        image: '',
        fileUrl: '',
        title: '',
        position: '',
        active: true,
        products: [],
        file: '',
      };
      this.selectedBanners = [];
      this.clickable = false;
    },
    remove(item) {
      const index = this.banner.products.indexOf(item.id);
      if (index >= 0) this.banner.products.splice(index, 1);
    },
  },
  created() {
    if (this.vid) {
      api
        .get('products')
        .then(r => {
          this.products = r.data;
        })
        .catch(async err => {
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.reload();
            }
          }
        });
      this.loadBanners();
    }
    this.headers = [
      {
        sortable: false,
        text: 'Image',
        value: 'image',
        align: 'center',
      },
      {
        sortable: true,
        text: 'Title',
        value: 'title',
        align: 'left',
      },
      {
        sortable: false,
        text: 'Position',
        value: 'position',
      },
      {
        sortable: true,
        text: 'Active',
        value: 'active',
        align: 'left',
      },
      {
        sortable: false,
        text: 'Products',
        align: 'center',
      },
    ];
  },
};
</script>
